import axios from 'axios'

export const generateComplementarColors = async (body) => {
  const ORQUESTRATOR_BASE_URL = import.meta.env.VITE_ORCHESTRATOR_URL
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .post(`${ORQUESTRATOR_BASE_URL}colors/palette`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error post art status', error.response.data)
      return error
    })
}